import React from "react";
import "./Tolbar.css";
import { MDBIcon } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";
const Tolbar = () => {
  const navigate = useNavigate();
  return (
    <div className="tolbar">
      <div className="Tolbar">
        <MDBIcon fas icon="user-circle" size="2x" />
        <p>محمد زاکانی</p>
      </div>
      <div className="dashbord">
        <MDBIcon className="Icon" fas icon="cloud" size="lg" />
        <MDBIcon className="Icon" fas icon="shopping-basket" size="lg" />
        <MDBIcon className="Icon" fas icon="sign-out-alt" size="lg" onClick={() => navigate("/")} />
      </div>
    </div>
  );
};

export default Tolbar;
